import * as React from 'react';
import * as constants from '../constants';
import crawlingChorusCover from '../resources/images/albumCover.png';
import debuggerCover from '../resources/images/debuggerCover.png';
import newMexicoCover from '../resources/images/newMexicoCover.png';
import bonVoyageCover from '../resources/images/bonVoyageCover.jpg';

function App() {
  return (
    <div className='layout'>
      <header>
        <h1>RIPSHIP</h1>
      </header>
      <div className='content'>
        {/* <h2>UTOPIA MUSIC VIDEO</h2>
        <VideoBlock videoSrc='https://www.youtube.com/embed/2oXqlqidnBM?si=p7jFUHhgumqL_hHH'></VideoBlock> */}
        <h2>SHOWS</h2>
        <LinkBlock
          mainText='MELB - BERGY BANDROOM - 14 MAR'
          href={constants.MEL_GIG}
        />
        <LinkBlock mainText='EU TOUR - APRIL/MAY 26' href={constants.EU_TOUR} />
        <h2>RELEASES</h2>
        <ReleaseBlock
          mainText='BON VOYAGE REMIXES'
          subText='ALPHABETHEAD + AMAMELIA'
          spotifyHref={constants.BON_VOYAGE_SPOTIFY}
          youtubeHref={constants.BON_VOYAGE_YOUTUBE}
          rightContent={
            <img alt='A sattelite flying through space' src={bonVoyageCover} />
          }
        />
        <ReleaseBlock
          mainText='CRAWLING CHORUS'
          subText='ALBUM OUT NOW'
          spotifyHref={constants.CRAWLING_CHORUS_SPOTIFY}
          bandcampHref={constants.CRAWLING_CHORUS_BANDCAMP}
          youtubeHref={constants.CRAWLING_CHORUS_YOUTUBE}
          rightContent={
            <img
              alt='the crawling chorus album cover, a sludgy mass of debris with a monsterous face'
              src={crawlingChorusCover}
            />
          }
        />
        <ReleaseBlock
          mainText='DEBUGGER'
          subText='SINGLE OUT NOW'
          spotifyHref={constants.DEBUG_SPOTIFY}
          bandcampHref={constants.DEBUG_BANDCAMP}
          youtubeHref={constants.DEBUG_YOUTUBE}
          rightContent={
            <img
              alt='the debugger single cover, a woman wearing a gas mask holds a can of fly spray to the camera'
              src={debuggerCover}
            />
          }
        />
        <ReleaseBlock
          mainText='NEW MEXICO'
          subText='SINGLE OUT NOW'
          spotifyHref={constants.NEWMEX_SPOTIFY}
          bandcampHref={constants.NEWMEX_BANDCAMP}
          youtubeHref={constants.NEWMEX_YOUTUBE}
          rightContent={
            <img
              alt='the new mexico single cover, the two band members pose atop a rocky mountain'
              src={newMexicoCover}
            />
          }
        />
        <h2>SOCIAL LINKS</h2>
        <section className='socialMediaWrapper'>
          <LinkBlock mainText='instagram' href={constants.instagramPath} />
          <LinkBlock mainText='spotify' href={constants.spotifyPath} />
          <LinkBlock mainText='bandcamp' href={constants.bandcampPath} />
          <LinkBlock mainText='tiktok' href={constants.tiktokPath} />
          <LinkBlock mainText='youtube' href={constants.youtubePath} />
          <LinkBlock mainText='facebook' href={constants.facebookPath} />
        </section>
      </div>
    </div>
  );
}

function LinkBlock(props) {
  return (
    <a
      className='linkBlock divBorder'
      rel='noreferrer nofollow'
      target='blank'
      href={props.href}
    >
      <span className='mainText'>{props.mainText}</span>
      <span className='subText'>{props.subText}</span>
    </a>
  );
}

function VideoBlock({ videoSrc }) {
  return (
    <div
      style={{
        position: 'relative',
        paddingBottom: '56.25%',
        height: 0,
        overflow: 'hidden',
      }}
    >
      <iframe
        src={videoSrc}
        title='YouTube video player'
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          border: 0,
        }}
        allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
        referrerPolicy='strict-origin-when-cross-origin'
        allowFullScreen
      />
    </div>
  );
}

function ReleaseBlock(props) {
  const links = [
    { linkText: 'spotify', href: props.spotifyHref },
    { linkText: 'youtube', href: props.youtubeHref },
    props.bandcampHref
      ? { linkText: 'bandcamp', href: props.bandcampHref }
      : null,
  ].filter(Boolean);

  return (
    <article className='releaseWrapper'>
      <div className='blockWrapper'>
        <div className='blockWrapperLeft divBorder'>
          <h3 className='mainText'>{props.mainText}</h3>
          <span className='subText'>
            {props.subTextHRef ? (
              <a
                rel='noreferrer nofollow'
                target='blank'
                href={props.subTextHRef}
              >
                {props.subText}
              </a>
            ) : (
              props.subText
            )}
          </span>
        </div>
        <div className='blockWrapperRight'>{props.rightContent}</div>
      </div>
      <div className='socialBlockWrapper'>
        {links.map((link) => (
          <a
            rel='noreferrer nofollow'
            target='blank'
            href={link.href}
            className='socialWrapper divBorder'
          >
            {link.linkText}
          </a>
        ))}
      </div>
    </article>
  );
}

export default App;
